export default __webpack_public_path__ + "static/media/green-check.743d71ea.gif";